/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to display a message.
 */
export class TextOutputCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the message content.
     */
    getMessage() {
        return this.getOutputByName('message', '');
    }
    /**
     * Gets the message type.
     * Official docs state this is a number, but in practice it's a string.
     */
    getMessageType() {
        return this.getOutputByName('messageType', '');
    }
}
